import { useMedia } from 'react-use';
import { Box, Heading, Paragraph, ToggleCard } from '@zillow/constellation-10';
import type { TourConfirmationType } from '@zg-rentals/ts-z-calendar-client';

import TourConfirmationTypeCard from '../../../TourConfirmationTypeCard';
import { TOUR_CONFIRMATION_TYPE_LAYOUT, TOUR_OPTIONS } from '../../../../constants/TourCalendar';

// Mirrors Panda's `breakpoints.md`. Inlined to avoid pulling `token()` into the bundle.
const MD_BREAKPOINT = '30em';

type TourCalendarConfigProps = {
  onTourTypeSelection: (tourType: TourConfirmationType) => void;
  tourConfirmationType?: TourConfirmationType;
};

const TourCalendarConfig = ({ onTourTypeSelection, tourConfirmationType }: TourCalendarConfigProps) => {
  const isScreenMobile = useMedia(`(max-width: ${MD_BREAKPOINT})`);

  return (
    <>
      <Box
        css={{
          gridColumnStart: { base: '2', md: '4' },
          gridColumnEnd: { base: 'span 22', md: 'span 10' },
          marginTop: { md: 'tighter' },
        }}
        data-testid="TourCalendarConfig-Body"
      >
        <Heading level={4} fontFamily="heading-alt" css={{ marginBottom: 'tighter' }}>
          Select the tour booking method that works best for you
        </Heading>
        <Paragraph color="text.subtle" css={{ marginBottom: { base: 'loose', md: 40 } }}>
          After a tour&apos;s scheduled, we&apos;ll send reminders so no one misses the tour. You can update your
          booking method at any time.
        </Paragraph>
      </Box>
      <Box css={{ gridColumnStart: { base: '2', md: '4' }, gridColumnEnd: { base: 'span 22', md: 'span 18' } }}>
        <Box
          css={{ display: 'flex', flexDirection: { base: 'column', md: 'row' }, gap: { base: 'default', md: 'loose' } }}
        >
          {TOUR_OPTIONS.map((tourOption, index) => (
            <ToggleCard
              css={{ maxWidth: { lg: '290px' } }}
              key={index}
              selected={tourOption.id === tourConfirmationType}
              onClick={() => onTourTypeSelection(tourOption.id)}
              data-testid={`TourCalendarConfig-TourType${index}`}
            >
              <TourConfirmationTypeCard
                layout={
                  isScreenMobile ? TOUR_CONFIRMATION_TYPE_LAYOUT.HORIZONTAL : TOUR_CONFIRMATION_TYPE_LAYOUT.VERTICAL
                }
                tourOption={tourOption}
              />
            </ToggleCard>
          ))}
        </Box>
      </Box>
    </>
  );
};

export default TourCalendarConfig;
